import axiosDefault from "../../api";

export const getNeighborhoodByRegisteredQuantity = async () => {
  const data = await axiosDefault.get('place/show-neighborhood-by-registered-person')
  return data;
}
